import { useState, useEffect, useCallback, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import SideMenu from './Sidemenu/SideMenu';
import LogoPicture from '../../pictures/logo.png';
import { sessionLogout } from '../login/redux/authApi';
import { swipeToggleStatus } from '../common/reduxs/swipe/reduxApi';
import { SCHOOL_NAME, SITE_ADDRESS, DEMO } from '../common/data/siteConfig';
import UserProfile from '../../pictures/user-default.png';
import { useUnamePass } from '../common/helpers/othersHelpers';
import Icon from '@mdi/react';
import {
  mdiAccountBox,
  mdiShieldKey,
  mdiLogout,
  mdiAlphaSCircle,
} from '@mdi/js';
import MenuOpen from '../common/icons/MenuOpen';
import MenuClose from '../common/icons/MenuClose';
import { sidebarToggleAction } from '../common/reduxs/sidebar/reduxAction';
import { ThemeContext } from '../main/ThemeProvider';

function Navbar() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { theme } = useContext(ThemeContext);

  // Redux state
  const auth = useSelector((state) => state.auth);
  const loading = useSelector((state) => state.async.loading);
  const menus = useSelector((state) => state.menus);
  const elementName = useSelector((state) => state.async.elementName);
  const swipe = useSelector((state) => state.swipe);
  const isShrunk = useSelector((state) =>
    state.sidebar ? state.sidebar.isShrunk : false,
  );

  // Local state
  const [width, setWidth] = useState(0);
  const [isTogglerActive, setIsTogglerActive] = useState(false);
  const [inside, setInside] = useState(false);

  const uPass = useUnamePass();
  const checkSA = auth?.authorities?.title?.[0] === 'SA';

  // Resize handler
  const onResizeEvent = useCallback(() => {
    const bodyElement = document.getElementsByTagName('BODY')[0];
    setWidth(bodyElement.offsetWidth);
  }, []);

  useEffect(() => {
    const bodyElement = document.getElementsByTagName('BODY')[0];
    setWidth(bodyElement.offsetWidth);
    window.addEventListener('resize', onResizeEvent, true);
    return () => {
      window.removeEventListener('resize', onResizeEvent, true);
    };
  }, [onResizeEvent]);

  const handleToggleShrunk = () => {
    dispatch(sidebarToggleAction(!isShrunk));
  };

  const handleToggler = () => {
    const burger = document.getElementById('burger');
    if (!isTogglerActive) {
      burger.classList.add('active');
      burger.classList.remove('not-active');
    } else {
      burger.classList.add('not-active');
      burger.classList.remove('active');
    }
    setIsTogglerActive((prev) => !prev);
  };

  const handleInsideClick = (value) => setInside(value);
  const handleTogglerOnOff = (value) => setIsTogglerActive(value);

  // const handleActiveLink = () => {
  //   const regex = new RegExp(`/profile/${auth.userId}`);
  //   return regex.test(location.pathname);
  // };

  const handleLink = (value) => {
    history.push(value.split('_')[0]);
  };

  const handleSessionLogout = (elName) => {
    if (uPass && uPass.length > 0) {
      window.ReactNativeWebView.postMessage('logout');
    }
    dispatch(sessionLogout(elName, history));
  };

  return (
    <>
      {auth.isAuth && (
        <nav id='navbarTop' className='navbar is-fixed-top box-shadow-y'>
          <div className='navbar-brand'>
            {auth.isAuth === true && (
              <div
                style={!uPass ? {} : { display: 'none' }}
                id='burger'
                onClick={handleToggler}
                className='navbar-burger toggler not-active is-hidden-tablet'
              >
                <span />
                <span />
                <span />
              </div>
            )}
            {auth.isAuth === true && (
              <div
                id='shrunkToggle'
                style={
                  !uPass
                    ? {
                        cursor: 'pointer',
                        zIndex: 100,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 10px 0 18px',
                      }
                    : { display: 'none' }
                }
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  handleToggleShrunk();
                }}
                className='is-hidden-mobile'
                title='Toggle Sidebar'
              >
                <div
                  style={{
                    position: 'relative',
                    width: 28,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 4,
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      transition: 'all 0.3s ease',
                      opacity: isShrunk ? 0 : 1,
                      transform: isShrunk
                        ? 'scale(0.5) rotate(-90deg)'
                        : 'scale(1) rotate(0deg)',
                    }}
                  >
                    <MenuOpen
                      size={25}
                      color={theme === 'dark' ? '#fff' : '#273645ff'}
                    />
                  </div>
                  <div
                    style={{
                      position: 'absolute',
                      transition: 'all 0.3s ease',
                      opacity: isShrunk ? 1 : 0,
                      transform: isShrunk
                        ? 'scale(1) rotate(0deg)'
                        : 'scale(0.5) rotate(90deg)',
                    }}
                  >
                    <MenuClose
                      size={25}
                      color={theme === 'dark' ? '#fff' : '#273645ff'}
                    />
                  </div>
                </div>
              </div>
            )}
            <div
              className='navbar-item is-size-5 has-text-weight-semibold hand-pointer2'
              onClick={() => handleLink('/dashboard_')}
              style={
                auth.isAuth === true && width < 769 && !uPass
                  ? { marginLeft: 38 }
                  : { backgroundColor: 'var(--card)' }
              }
            >
              <div
                style={{
                  backgroundColor: 'var(--logo-bg)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 22,
                  height: 22,
                }}
              >
                {DEMO ? (
                  <Icon
                    path={mdiAlphaSCircle}
                    size={3}
                    color='var(--bg-side-menu)'
                  />
                ) : (
                  <img
                    alt='profile-pic'
                    src={LogoPicture}
                    style={{ height: 20, width: 'auto' }}
                  />
                )}
              </div>
              <span className='ml-1'>
                {DEMO ? 'PORTAL SEKOLAH' : SCHOOL_NAME}
              </span>
            </div>
          </div>
          {auth.isAuth && (
            <div className='navbar-menu'>
              <div className='navbar-end'>
                <div className='navbar-item has-dropdown is-hoverable'>
                  <div id='navUser' className='navbar-item hand-pointer'>
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        backgroundImage: `url(${
                          auth && auth.profile && auth.profile.photo
                            ? SITE_ADDRESS + auth.profile.photo
                            : UserProfile
                        })`,
                        borderRadius: '50%',
                        backgroundSize: 'cover',
                      }}
                    />
                    <span className='has-text-weight-semibold is-size-7 ml-2'>
                      {auth.username && auth.username.length < 6 ? (
                        <span className='is-uppercase'>
                          {auth.username.toLowerCase()}
                        </span>
                      ) : (
                        <span className='is-capitalized'>{auth.username}</span>
                      )}
                    </span>
                  </div>
                  <div className='navbar-dropdown is-right'>
                    <div
                      className='navbar-item hand-pointer'
                      onClick={() => handleLink('/profil/info')}
                    >
                      <span className='flex justify-start align-center'>
                        <Icon path={mdiAccountBox} size={0.65} />
                        <span className='ml-1'>Profil</span>
                      </span>
                    </div>
                    {!checkSA && (
                      <div
                        className='navbar-item hand-pointer'
                        onClick={() => handleLink('/profil/ubah-password')}
                      >
                        <span className='flex justify-start align-center'>
                          <Icon path={mdiShieldKey} size={0.65} />
                          <span className='ml-1'>Ubah Password</span>
                        </span>
                      </div>
                    )}
                    {loading === true && elementName === 'logoutNav' ? (
                      <button
                        disabled
                        className='button is-loading is-text is-small'
                      >
                        <span className='flex justify-start align-center'>
                          <Icon path={mdiLogout} size={0.65} />
                          <span className='ml-1'>Logout</span>
                        </span>
                      </button>
                    ) : (
                      <div
                        onClick={() => handleSessionLogout('logoutNav')}
                        className='navbar-item hand-pointer'
                      >
                        <span className='flex justify-start align-center'>
                          <Icon path={mdiLogout} size={0.65} />
                          <span className='ml-1'>Logout</span>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </nav>
      )}
      {auth.isAuth && (
        <SideMenu
          toggler={isTogglerActive}
          inside={inside}
          swipeToggleStatus={(val) => dispatch(swipeToggleStatus(val))}
          swipe={swipe}
          handleInsideClick={handleInsideClick}
          handleTogglerOnOff={handleTogglerOnOff}
          profile={auth.profile}
          auth={auth}
          menus={menus}
          logout={handleSessionLogout}
          loading={loading}
          elementName={elementName}
          pathname={location.pathname}
          history={history}
          isShrunk={isShrunk}
        />
      )}
    </>
  );
}

export default Navbar;
